// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCianApiSiteV1GetQuickLinksRequest,
  TCianApiSiteV1GetQuickLinksModel,
  IMappers,
  TCianApiSiteV1GetQuickLinksResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetQuickLinksResponseSchema100 } from '../../../../entities/schemas/GetQuickLinksResponseSchema100';
import type { IErrorResponseSchema101 } from '../../../../entities/schemas/ErrorResponseSchema101';

export function createCianApiSiteV1GetQuickLinksModel(
  parameters: TCianApiSiteV1GetQuickLinksRequest,
): TCianApiSiteV1GetQuickLinksModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'POST',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/get-quick-links/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICianApiSiteV1GetQuickLinksOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCianApiSiteV1GetQuickLinksRequest;
}

export async function fetchCianApiSiteV1GetQuickLinks<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1GetQuickLinksOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCianApiSiteV1GetQuickLinksResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1GetQuickLinksModel(parameters),
    config,
  )) as FetchResponse<TCianApiSiteV1GetQuickLinksResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuickLinksResponseSchema100, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema101, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1GetQuickLinksResponse>;
}
